import { render, staticRenderFns } from "./OrderPlaced.vue?vue&type=template&id=31e407b9"
import script from "./OrderPlaced.vue?vue&type=script&lang=js"
export * from "./OrderPlaced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports